import {
  Tv,
  Sofa,
  DoorOpen,
  Wrench,
  PaintRoller,
  Brush,
  Fan,
  Lightbulb,
  LayoutGrid,
  Fence,
  Layers,
  Ruler,
  Boxes,
  ShowerHead,
  ChefHat,
  Droplets,
  Home as HomeIcon,
  Building2,
  Store,
  Hammer,
  Tag,
  Car,
  Users,
  MapPin,
  Zap,
  Clock,
  Sparkles,
  BadgeDollarSign,
} from "lucide-react";

export const WHY_US = [
  { title: "Flat, upfront pricing", icon: Tag, desc: "Our most-requested jobs are flat-priced right here on the site." },
  { title: "Two services, one visit", icon: Car, desc: "Handyman and mobile car detailing from the same local team." },
  { title: "Residential & commercial", icon: Users, desc: "Homeowners, landlords, offices, retail — any property." },
  { title: "Based in Salisbury, MD", icon: MapPin, desc: "Local to Delmarva. We know the neighborhoods we serve." },
  { title: "Fast replies", icon: Zap, desc: "Quick to answer calls, texts, and estimate requests." },
  { title: "Flexible scheduling", icon: Clock, desc: "Evenings and weekends available by appointment." },
  { title: "Clean, respectful work", icon: Sparkles, desc: "We leave the space tidier than we found it." },
  { title: "Honest quotes", icon: BadgeDollarSign, desc: "Materials and specialty hardware are quoted up front." },
];

export const CONTACT = {
  phone: "+1 (443) 366-9615",
  phoneRaw: "+14433669615",
  altPhone: "+1 (667) 271-0842",
  altPhoneRaw: "+16672710842",
  emailPrimary: "rshandyserv@gmail.com",
  emailSecondary: "svintsitskyiroman@gmail.com",
  serviceArea: "Maryland & Delaware",
  serviceAreaFull: "Based in Salisbury, MD — serving Eastern Shore MD & Delaware",
  thumbtackUrl:
    "https://www.thumbtack.com/md/willards/handyman/rs-handyman-services/service/574541349768077312",
  social: {
    facebook: "https://facebook.com/",
    instagram: "https://instagram.com/",
    google: "https://google.com/",
  },
};

// Booking policy — confirmed by the business owner.
export const BOOKING_POLICY = {
  anchorCity: "Salisbury, MD",
  salisburyMinimum: "$0",
  outOfTownMinimum: "$120",
  radiusMiles: 15,
};

export const SERVICES = [
  { title: "TV Mounting", icon: Tv, desc: "Secure, level mounts on any wall type.", from: "$100" },
  { title: "Furniture Assembly", icon: Sofa, desc: "IKEA, Wayfair, custom pieces.", from: "Custom Quote" },
  { title: "Door Repair & Install", icon: DoorOpen, desc: "Interior, exterior & storm doors.", from: "Custom Quote" },
  { title: "Drywall Repair", icon: Wrench, desc: "Holes, cracks, seamless patching.", from: "Custom Quote" },
  { title: "Interior Painting", icon: PaintRoller, desc: "Clean lines, premium finishes.", from: "Custom Quote" },
  { title: "Exterior Painting", icon: Brush, desc: "Weather-resistant coatings.", from: "Custom Quote" },
  { title: "Ceiling Fan Install", icon: Fan, desc: "Safely wired & perfectly balanced.", from: "Custom Quote" },
  { title: "Light Fixture Install", icon: Lightbulb, desc: "Chandeliers to recessed lighting.", from: "Custom Quote" },
  { title: "Shelving Installation", icon: LayoutGrid, desc: "Floating, built-in & garage.", from: "Custom Quote" },
  { title: "Fence Repair", icon: Fence, desc: "Wood, vinyl & chain link fixes.", from: "Custom Quote" },
  { title: "Flooring Installation", icon: Layers, desc: "LVP, laminate, tile & vinyl.", from: "Custom Quote" },
  { title: "Trim & Baseboard", icon: Ruler, desc: "Crown molding, casings & more.", from: "Custom Quote" },
  { title: "Cabinet Installation", icon: Boxes, desc: "Kitchen, bath & garage cabinets.", from: "Custom Quote" },
  { title: "Bathroom Repairs", icon: ShowerHead, desc: "Fixtures, tile, vanity & more.", from: "Custom Quote" },
  { title: "Kitchen Repairs", icon: ChefHat, desc: "Faucets, disposals, cabinets.", from: "Custom Quote" },
  { title: "Pressure Washing", icon: Droplets, desc: "Driveways, siding, decks & fences.", from: "Custom Quote" },
  { title: "Home Maintenance", icon: HomeIcon, desc: "Seasonal upkeep & tune-ups.", from: "Custom Quote" },
  { title: "Property Maintenance", icon: Building2, desc: "Landlord & rental turnovers.", from: "Custom Quote" },
  { title: "Commercial Maintenance", icon: Store, desc: "Offices, retail & restaurants.", from: "Custom Quote" },
  { title: "Custom Handyman Projects", icon: Hammer, desc: "If you can dream it, we can build it.", from: "Custom Quote" },
];

// Popular services highlighted on the homepage hero.
export const POPULAR_HERO_SERVICES = [
  { title: "TV Mounting", from: "$100" },
  { title: "Picture Hanging", from: "$20" },
  { title: "Mirror Hanging", from: "$25" },
  { title: "Curtain Rods / Blinds", from: "$35" },
  { title: "Mobile Car Detailing", from: "$250" },
];

// Pricing — confirmed by the business owner. Materials and specialized
// hardware may cost extra; "Custom Quote" items are confirmed on request.
export const PRICING_GROUPS = [
  {
    title: "TV Mounting",
    subtitle: "By screen size",
    icon: Tv,
    items: [
      { label: "Under 60\"", price: "$100" },
      { label: "60 – 69\"", price: "$120" },
      { label: "70 – 79\"", price: "$140" },
      { label: "80 – 89\"", price: "$160" },
      { label: "90\" and up", price: "Custom Quote" },
    ],
  },
  {
    title: "Picture Hanging",
    subtitle: "Per piece",
    icon: LayoutGrid,
    items: [
      { label: "Small", price: "$20" },
      { label: "Medium", price: "$30" },
      { label: "Large", price: "$40" },
    ],
  },
  {
    title: "Mirror Hanging",
    subtitle: "Per piece",
    icon: Layers,
    items: [
      { label: "Small", price: "$25" },
      { label: "Medium", price: "$35" },
      { label: "Large", price: "$45" },
    ],
  },
  {
    title: "Window Installations",
    subtitle: "Each",
    icon: Ruler,
    items: [
      { label: "Curtain Rods", price: "$35" },
      { label: "Blinds", price: "$35" },
    ],
  },
];

export const ADDITIONAL_SERVICES = [
  { title: "Furniture Assembly", icon: Sofa, note: "Custom Quote" },
  { title: "Interior & Exterior Painting", icon: PaintRoller, note: "Custom Quote" },
  { title: "Drywall Repairs", icon: Wrench, note: "Custom Quote" },
  { title: "Shelving Installation", icon: LayoutGrid, note: "Custom Quote" },
  { title: "Door Repairs", icon: DoorOpen, note: "Custom Quote" },
  { title: "Deck Repairs", icon: Layers, note: "Custom Quote" },
  { title: "General Home Maintenance", icon: HomeIcon, note: "Custom Quote" },
];

// Mobile Car Detailing — confirmed main package + upgrades
export const DETAILING_MAIN_PACKAGE = {
  title: "Full Interior & Exterior Detail",
  price: "$250",
  vehicleNote: "Standard passenger vehicle",
  includes: [
    "Exterior hand wash",
    "Wheel and tire cleaning",
    "Brake dust and road grime removal",
    "Interior vacuuming",
    "Compressed-air cleaning",
    "Dashboard, console, and trim cleaning",
    "Window cleaning",
    "Leather cleaning and conditioning when applicable",
  ],
};

export const DETAILING_UPGRADES = [
  { title: "Wax Protection", price: "From $80" },
  { title: "Deep Seat Extraction", price: "From $60" },
  { title: "Carpet Deep Cleaning", price: "From $50" },
  { title: "Pet Hair Removal", price: "From $30" },
  { title: "Heavy Stain Removal", price: "Custom Quote" },
];

export const AUTO_DETAILING = {
  heroImage:
    "https://images.unsplash.com/photo-1552519507-da3b142c6e3d?auto=format&fit=crop&w=1400&q=80",
  benefits: [
    "We come to you — home, work, or any suitable spot",
    "No driving to a detailing shop or waiting in line",
    "Interior and exterior cleaning in one visit",
    "Flexible scheduling that works around your day",
  ],
};

export const MARQUEE_WORDS = [
  "TV Mounting",
  "Picture Hanging",
  "Mirror Hanging",
  "Furniture Assembly",
  "Mobile Car Detailing",
  "Drywall Repair",
  "Interior Painting",
  "Flooring",
  "Pressure Washing",
  "Cabinet Install",
  "Deck Repairs",
  "Property Maintenance",
];

// Contact form service options
export const SERVICE_OPTIONS = [
  "Handyman — TV / Picture / Mirror Mounting",
  "Handyman — Furniture Assembly",
  "Handyman — Painting",
  "Handyman — Drywall / Repair",
  "Handyman — Door / Flooring / Deck",
  "Handyman — Other / Custom",
  "Mobile Car Detailing — Full Interior & Exterior ($250)",
  "Mobile Car Detailing — Add-on upgrade",
  "Not sure — recommend a service",
];

// Service area cities we actively accept jobs in.
export const SERVICE_CITIES = {
  Maryland: [
    "Salisbury",
    "Fruitland",
    "Delmar",
    "Willards",
    "Berlin",
    "Ocean City",
    "Snow Hill",
    "Pocomoke City",
    "Easton",
    "Cambridge",
  ],
  Delaware: [
    "Seaford",
    "Georgetown",
    "Milford",
    "Lewes",
    "Rehoboth Beach",
    "Dover",
    "Milton",
  ],
};

// Verified customer reviews supplied by the business.
// Fake / unverified placeholder reviews have been removed per audit.
export const TESTIMONIALS = [];

export const FAQS = [
  {
    q: "Do you charge a minimum booking amount?",
    a: "No minimum for Salisbury residents. For customers more than 15 miles from Salisbury, a $120 minimum total booking amount applies. This is a project minimum — not an additional travel fee.",
  },
  {
    q: "What areas do you serve?",
    a: "We're based in Salisbury, MD and serve the Eastern Shore of Maryland and Delaware — including Salisbury, Fruitland, Delmar, Berlin, Ocean City, Snow Hill, Pocomoke, Easton, Cambridge, Seaford, Georgetown, Lewes, Rehoboth Beach, Dover and surrounding towns. Not sure if you're in range? Give us a call.",
  },
  {
    q: "Do you offer mobile car detailing?",
    a: "Yes. Our Full Interior & Exterior Detail for a standard passenger vehicle is $250 and includes exterior hand wash, wheel & tire cleaning, interior vacuuming, dashboard/console/trim cleaning, window cleaning, and leather conditioning when applicable. Upgrades like wax protection, deep seat extraction, carpet deep cleaning, and pet hair removal are available.",
  },
  {
    q: "What payment methods do you accept?",
    a: "Cash, major credit/debit cards, Zelle, Venmo, and Cash App. Payment is due upon completion unless otherwise agreed.",
  },
  {
    q: "Do you work on weekends?",
    a: "Yes — flexible scheduling including evenings and weekends by appointment.",
  },
  {
    q: "Will materials cost extra?",
    a: "Posted prices cover standard labor. Materials and specialized hardware (e.g., in-wall cable kits, specialty mounts, heavy-duty anchors) may cost extra and are quoted up front before work begins.",
  },
  {
    q: "Do you install TVs on brick, tile, or stone?",
    a: "Yes — flat prices by TV size cover standard drywall mounts. Mounting on brick, tile, stone, or concrete is quoted on request since it requires specialty anchors.",
  },
  {
    q: "Do you provide commercial services?",
    a: "Yes. We work with property managers, landlords, offices, restaurants, and retail spaces on both one-time and ongoing maintenance.",
  },
];

// Gallery is intentionally held back until real project photos are supplied.
// Clearly-labeled placeholder cards are shown instead of stock imagery.
export const GALLERY_CATEGORIES = [
  "Kitchen & Cabinets",
  "Painting",
  "TV Mounting",
  "Furniture Assembly",
  "Home Repairs",
  "Deck Improvements",
];
